<template>
  <div>
    <h3>优惠券套票管理</h3>
    <el-form :inline="true" ref="filter" class="demo-form-inline" size="mini">
      <el-form-item label="套券id">
        <el-input v-model.number="filter.id" placeholder="活动id"></el-input>
      </el-form-item>
      <el-form-item label="套券名称">
        <el-input
          v-model.number="filter.packageName"
          placeholder="活动id"
        ></el-input>
      </el-form-item>
      <el-form-item label="套券活动时间">
        <el-date-picker
          v-model="filter.startTime"
          type="date"
          placeholder="开始时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd HH:mm:ss"
          :editable="false"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="至">
        <el-date-picker
          v-model="filter.endTime"
          type="date"
          placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :editable="false"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fetch()" size="mini">查询</el-button>
        <el-button @click="reset()" size="mini">重置</el-button>
        <el-button
          type="primary"
          plain
          @click="$router.push('/coupon/buyActivity')"
          size="mini"
          >新增套票</el-button
        >
      </el-form-item>
    </el-form>
    <el-table :data="list" size="mini" v-loading="loading">
      <el-table-column prop="id" label="套券id"></el-table-column>
      <el-table-column
        prop="packageName"
        width="200px"
        label="套券名称"
      ></el-table-column>

      <el-table-column prop="preferentialPrice" label="金额" />

      <el-table-column
        prop="originalPrice"
        width="120px"
        label="划线价 （元）"
      />
      <el-table-column
        prop="validTime"
        width="120px"
        label="套券有效期 （天）"
      />
      <el-table-column prop="" width="200px" label="套券活动时间">
        <template slot-scope="scope">
          <span v-if="scope.row.startTime && scope.row.endTime">
            {{ scope.row.startTime }} 至 {{ scope.row.endTime }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="可售范围">
        <template slot-scope="scope">
          {{
            scope.row.type == 1
              ? "新用户"
              : scope.row.type == 2
              ? "老用户"
              : "全部"
          }}
        </template>
      </el-table-column>
      <el-table-column prop="isOnline" label="状态">
        <template slot-scope="scope">
          <!-- {{ scope.row.isOnline == "1" ? "开启" : "锁定" }} -->
          <el-button v-if="scope.row.isOnline == 1" type="text">开启</el-button>
          <el-button v-else type="text" style="color: #606266">锁定</el-button>
        </template>
      </el-table-column>

      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-dropdown size="medium" @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-menu" style="font-size: 24px"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="">
                <a
                  :href="`/coupon/buyActivity?id=${scope.row.id}`"
                  target="_blank"
                  >编辑</a
                >
              </el-dropdown-item>
              <el-dropdown-item command="">
                <el-button size="mini" type="text" @click="handleDel(scope.row)"
                  >删除</el-button
                >
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <div>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="pageNum"
        @current-change="(i) => (pageNum = i)"
        :page-size="limit"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import map from "../../datamap";
import api from "../api";
import Clipboard from "clipboard";
const { coupon } = api;

export default {
  name: "couponActivities",
  data() {
    return {
      map,
      filter: {
        id: "",
        activityType: "",
        startTime: "",
        endTime: "",
        packageName: "",
      },
      loading: true,
      list: [],
      total: 0,
      limit: 20,
      pageNum: 1,
      total: 0,
      isSubmiting: false,
    };
  },
  components: {},
  computed: {},
  watch: {
    pageNum() {
      this.fetch(2);
    },
  },
  methods: {
    async fetch(num) {
      if (num == 1) {
        this.pageNum = 1;
      }
      let pageNum = this.pageNum;
      let limit = this.limit;
      this.loading = true;

      let { id, startTime, endTime, activityType, packageName } = this.filter;
      let obj = {
        pageNum: pageNum,
        limit: limit,
        id: Number.isInteger(id) ? id : "",
        startTime,
        endTime,
        activityType,
        packageName,
      };

      let res = await coupon.couponPackage(obj);

      this.list = res.data.data;
      this.loading = false;
      this.total = res.data.pageinfo.totalCount;
    },
    handleCommand() {},
    reset() {
      this.pageNum = 1;
      this.filter = {};

      this.fetch();
    },
    async handleDel(row) {
      try {
        let text = "是否确认删除套券id为" + row.id + "的数据?";
        await this.$confirm(text, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        let res = await coupon.packageDel({ id: row.id });

        let { code } = res.data;
        if (code === 200) {
          this.$message.success("删除数据成功");
        }
        this.fetch();
      } catch (e) {
        this.$message({
          type: "info",
          message: "已取消删除",
        });
      }
    },
  },
  mounted() {
    this.fetch();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/views/coupon/packageList.vue